import { Plan } from '@/api';
import { ADDITION_MARK_TO_CATEGORY, PlanCategoryEnum } from '@/config';

const sortPlansByCategory = (planList: Plan[] = []) => {
  const allPlans = [...planList];
  const tempCategories: Record<string, Plan[]> = Object.values(
    ADDITION_MARK_TO_CATEGORY,
  ).reduce(
    (result, cat) => {
      result[cat] = [];
      return result;
    },
    {} as Record<string, any[]>,
  );

  allPlans.forEach((plan) => {
    const listKey = ADDITION_MARK_TO_CATEGORY[
      plan.addition
    ] as PlanCategoryEnum;

    tempCategories[listKey].push(plan);
  });

  return tempCategories;
};

export default sortPlansByCategory;
